import React from 'react';
import styled from 'styled-components';
import { Switch, Card, Icon } from 'components';
import { useBreakpoint } from 'hooks';
import { Covid19Settings } from '@bb/domain/dist/types';
import {
  StyledButton,
  StyledGrid,
} from '../../Router/pages/OrgSettingsPage/StyledComponents';

type COVID19SettingsProps = {
  handleToggle: (field: string, val: any) => void;
  handleEditAckTemplate: () => void;
  handleEditPopupTemplate: () => void;
  settings: Covid19Settings;
};

const COVID19Settings: React.FC<COVID19SettingsProps> = ({
  handleToggle,
  handleEditAckTemplate,
  handleEditPopupTemplate,
  settings,
}) => {
  const breakpoints = useBreakpoint();
  return (
    <Card type="primary" title="COVID-19 Settings" id="covid-19">
      <StyledGrid $breakpoints={breakpoints}>
        <Switch
          label="MLS Booking Warning Pop Up"
          data-cy="config-booking-warning-popup"
          onClick={() =>
            handleToggle('mlsBookingPopup', !settings.mlsBookingPopup)
          }
          checked={settings.mlsBookingPopup}
          addonAfter={
            settings.mlsBookingPopup && (
              <>
                <StyledButton
                  size="small"
                  data-cy="config-booking-warning-popup-edit"
                  onClick={e => {
                    e.preventDefault();
                    handleEditPopupTemplate();
                  }}
                >
                  <Icon
                    type="antdEditOutlined"
                    height={10.95}
                    width={10.95}
                    offset={[0, -3]}
                    color="gray10"
                  />
                  Edit
                </StyledButton>
              </>
            )
          }
        />
        <Switch
          label="New Booking Mandatory Waiver"
          data-cy="config-booking-mandatory-ack"
          onClick={() => handleToggle('newBookingAck', !settings.newBookingAck)}
          checked={settings.newBookingAck}
          addonAfter={
            settings.newBookingAck && (
              <>
                <StyledButton
                  size="small"
                  data-cy="config-booking-mandatory-ack-edit"
                  onClick={e => {
                    e.preventDefault();
                    handleEditAckTemplate();
                  }}
                >
                  <Icon
                    type="antdEditOutlined"
                    height={10.95}
                    width={10.95}
                    offset={[0, -3]}
                    color="gray10"
                  />
                  Edit
                </StyledButton>
              </>
            )
          }
        />
        <Switch
          label="COVID-19 Precautions button"
          data-cy="config-email-covid-button"
          onClick={() => {
            handleToggle(
              'covid19PrecautionsBtn',
              !settings.covid19PrecautionsBtn,
            );
          }}
          checked={settings.covid19PrecautionsBtn}
        />
      </StyledGrid>
    </Card>
  );
};

const StyledSwitchWrapper = styled.div``;

export default COVID19Settings;
